/**
 * Customer.io API Helper
 *
 * Handles the formatting of the URL and executing the fetch function
 *
 * @param   {String} endpoint       The Customer.io API endpoint to call.
 * @param   {String} method         (Optional) The method for the call. Defaults to POST.
 * @param   {Object} body           (Optional) The body of the call. Should be a JSON object.
 *
 * @return  {Object}                {response, status}
 */
async function customerioApi(formId, body) {
  const siteId = process.env.GATSBY_CUSTOMER_IO_SITE_ID || '';
  const endpoint = 'https://eu.customerioforms.com/forms/submit_action';
  const url = new URL(endpoint);

  const queryParams = {
    site_id: siteId,
    form_id: formId,
    success_url: window.location.href
  };
  Object.keys(queryParams).forEach(key => url.searchParams.append(key, queryParams[key]));

  const options = {
    method: 'POST',
    body: JSON.stringify(body),
    redirect: 'manual' // Prevent automatic following of redirects
  };

  const response = await fetch(url, options);

  return { status: response.status };
}

/**
 * Subscribe to Back In Stock Notification
 *
 * @param {Object} data  The data to be sent to the Customer.io API
 * @return {Object}      The response from the Customer.io API
 */
// async function subscribeBackInStock(data) {
//   return await customerioApi('65fcb9cd895b4fd', data);
// }

/**
 * Subscribe to Newsletter
 *
 * @param {Object} data  The data to be sent to the Customer.io API
 * @return {Object}      The response from the Customer.io API
 */
async function subscribeNewsletter(data) {
  const newsletterId = process.env.GATSBY_CUSTOMER_IO_NEWSLETTER_ID || '';
  return await customerioApi(newsletterId, data);
}


/**
 * Join Club
 *
 * @param {Object} data  The data to be sent to the Customer.io API
 * @return {Object}      The response from the Customer.io API
 */
async function joinClub(data) {
  const joinClubId = process.env.GATSBY_CUSTOMER_IO_CLUB_ID || '';
  localStorage.setItem('isClubSubmitted', 'true');
  return await customerioApi(joinClubId, data);
}

export { customerioApi, subscribeNewsletter, joinClub };
